import React, { memo, useMemo } from 'react';
import { Col, Row } from 'antd';
import { MenuItemCard } from 'widgets/menu/';
import { getWithoutSpaces } from 'common/helpers/format.helper';
import { ECategoryType, IMenuCategory, IMenuItemWithCategoryNameAndType } from 'entities/Menu/Menu.models';

interface IComponentProps {
  category: IMenuCategory;
  isDefaultMenu: boolean;
  isRowView?: boolean;
  onMenuItemClick(item: IMenuItemWithCategoryNameAndType): void;
}

const MenuCategoriesListItemComponent: React.FC<IComponentProps> = ({ category, isDefaultMenu, onMenuItemClick, isRowView }) => {
  const name = category.name;
  const items = category.menuItemsToAsset ?? [];
  const type = category.type as ECategoryType;

  const anchorId = useMemo(() => getWithoutSpaces(name), [name]);

  const enrichedItems: IMenuItemWithCategoryNameAndType[] = useMemo(
    () => items.map((item) => ({ ...item, category: name, type })),
    [items, name, type],
  );

  return (
    <>
      <div className="menu-card-sign mt-7" id={anchorId}>
        {!isRowView ? name : ''}
      </div>

      <Row gutter={[24, 24]}>
        {enrichedItems.map((item) => (
          <Col sm={isRowView ? 24 : 12} lg={isRowView ? 24 : 8} xs={24} key={item.id}>
            <MenuItemCard item={item} isDefaultMenu={isDefaultMenu} onClick={onMenuItemClick} isRowView={isRowView} />
          </Col>
        ))}
      </Row>
    </>
  );
};

export const MenuCategoriesListItem = memo(MenuCategoriesListItemComponent);
